import React, { useEffect, useState } from 'react'
import { calendarStyles } from './calendarHelpers'
import dateFormat from 'dateformat'
import DateRangeIcon from '@material-ui/icons/DateRange'
import AgentAvatar from '../AgentAvatar'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { IconButton, Button, CircularProgress } from '@material-ui/core'
import { formatRFC3339 } from 'date-fns'

function CalendarHeader (props) {
  const classes = calendarStyles()

  return (
    <div className={classes.calendarDropHeader} style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div className={classes.title}>
        <DateRangeIcon />
        <span style={{ marginLeft: 8 }}>{props.drop.data.meeting_type}</span>
      </div>
      <div>
        {props.drop.data.duration} min
      </div>
    </div>
  )
}

function SlotButton (props) {
  return (
    <Button
      variant='outlined'
      fullWidth
      style={{
        border: '1px solid rgb(0,0,0)',
        minHeight: 40,
        fontSize: '13px',
        textTransform: 'none',
        lineHeight: 1.3
      }}
      onClick={props.onClick}
    >
      {props.text}
    </Button>
  )
}

function PageSubHeader (props) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '36px auto 36px', height: 36 }}>
      {props.back
        ? (
          <IconButton
            onClick={props.back}
            style={{ padding: 6 }}
          >
            <ArrowBackIcon />
          </IconButton>
        )
        : <div />}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
        {props.heading}
      </div>

    </div>
  )
}

function DayPicker (props) {
  const classes = calendarStyles()

  return (
    <div className={classes.calendarPage}>
      <PageSubHeader
        heading='Select a day'
        back={() => props.setShowMore(false)}
      />
      <div className={classes.slotsDiv}>
        {props.days.map((d, index) => {
          const text = dateFormat(new Date(d), 'ddd, mmm dS')
          return (
            <SlotButton
              key={index}
              onClick={() => props.setDay(d)}
              text={text}
            />
          )
        })}
      </div>
    </div>
  )
}

function DateTimePicker (props) {
  const classes = calendarStyles()

  const allAvailability = Object.values(props.slots)
  const todaysAvailability = allAvailability[0]
  const tomorrowsAvailability = allAvailability[1]
  let times = []
  if (todaysAvailability.length > 1) {
    times = todaysAvailability.slice(0, 2)
    times = times.concat(tomorrowsAvailability[0])
  } else {
    times = todaysAvailability
    if (tomorrowsAvailability.length > 1) {
      times = times.concat(tomorrowsAvailability.slice(0, 2))
    } else {
      times = times.concat(tomorrowsAvailability[0])
      times = times.concat(allAvailability[1][0])
    }
  }

  return (
    <div className={classes.calendarPage}>
      <PageSubHeader
        heading='Select an appointment'
      />
      <div className={classes.dateAndTimeSlotsDiv}>
        {times.map((t, index) => {
          const text = dateFormat(t, 'dddd, mmmm dS - h:MM TT Z')
          return (
            <SlotButton
              key={index}
              text={text}
              onClick={() => props.setDateTime(t)}
            />
          )
        })}
      </div>
      <div className={classes.optionsText} onClick={() => props.setShowMore(true)}>
        More options
      </div>
    </div>
  )
}

function TimePicker (props) {
  const classes = calendarStyles()

  const formattedDay = props.day ? dateFormat(new Date(props.day), 'dddd, mmmm, dS yyyy') : ''

  const times = props.slots[props.day]
  return (
    <div className={classes.calendarPage}>
      <PageSubHeader
        back={props.back}
        heading={formattedDay}
      />
      <div className={classes.slotsDiv}>
        {times.map((t, index) => {
          const text = dateFormat(t, 'h:MM TT')
          return (
            <SlotButton
              key={index}
              text={text}
              onClick={() => props.setDateTime(t)}
            />
          )
        })}
      </div>
    </div>
  )
}

function ConfirmationPage (props) {
  const classes = calendarStyles()

  const endDateTime = new Date(props.startTime.getTime() + props.duration * 60000)
  const meetingTimeString = dateFormat(props.startTime, 'h:MM') + ' - ' + dateFormat(endDateTime, 'h:MM TT')

  const start = formatRFC3339(props.startTime)
  const end = formatRFC3339(endDateTime)

  useEffect(() => {
    props.startHandler(start, props.startTime.getTime())
    props.endHandler(end, endDateTime.getTime())
  }, [])

  return (
    <div className={classes.calendarPage}>
      <PageSubHeader
        back={props.back}
        heading={props.formattedDay}
      />
      <div style={{ padding: '10px 20px' }}>
        <div className={classes.meetingTime}>
          {meetingTimeString}
        </div>
        <div style={{ marginBottom: 10, position: 'relative' }}>
          <Button
            fullWidth
            color='primary'
            variant='contained'
            onClick={() => {
              props.statushandler('dateSelected')
            }}
          >
            Schedule Meeting
          </Button>
        </div>
        <Button
          fullWidth
          variant='outlined'
          onClick={props.back}
        >
          Cancel
        </Button>
      </div>
    </div>
  )
}

function SlotPicker (props) {
  const [showMore, setShowMore] = useState(false)
  const [day, setDay] = useState(null)
  const [dateTime, setDateTime] = useState(null)

  const days = Object.keys(props.slots)

  const formattedDay = dateTime ? dateFormat(new Date(dateTime), 'dddd, mmmm, dS yyyy') : ''

  if (dateTime) {
    return (
      <ConfirmationPage
        back={() => setDateTime(null)}
        formattedDay={formattedDay}
        duration={props.drop.data.duration}
        startTime={dateTime}
        dropEventID={props.drop.event_id}
        statushandler={props.statushandler}
        startHandler={props.startHandler}
        endHandler={props.endHandler}
      />
    )
  }
  if (!showMore) {
    return (
      <DateTimePicker
        formattedDay={formattedDay}
        slots={props.slots}
        setDateTime={setDateTime}
        setShowMore={setShowMore}
      />
    )
  } else if (day) {
    return (
      <TimePicker
        day={day}
        slots={props.slots}
        back={() => setDay(null)}
        setDateTime={setDateTime}
      />
    )
  }

  return (
    <DayPicker
      days={days}
      setDay={setDay}
      setShowMore={setShowMore}
    />
  )
}

function CalendarBody (props) {
  const classes = calendarStyles()

  if (!props.slots) {
    return (
      <div className={classes.calendarDropLoading}>
        <CircularProgress
          style={{ height: 60, width: 60 }}
        />
      </div>
    )
  }

  return (
    <div className={classes.calendarDropBody}>
      <div>
        <div className={classes.agentNameDiv}>
          {props.agentName}
        </div>
        <div className={classes.agentAvatarDiv}>
          <AgentAvatar
            avatarUrl={props.avatarUrl}
            size={60}
          />
        </div>
      </div>
      <SlotPicker
        slots={props.slots}
        drop={props.drop}
        statushandler={props.statushandler}
        startHandler={props.startHandler}
        endHandler={props.endHandler}
      />
    </div>
  )
}

function DatePicker (props) {
  const classes = calendarStyles()

  return (
    <div className={classes.calendarDropOuter}>
      <CalendarHeader
        drop={props.drop}
      />
      <CalendarBody
        avatarUrl={props.avatarUrl}
        agentName={props.agentName}
        slots={props.slots}
        drop={props.drop}
        statushandler={props.statushandler}
        startHandler={props.startHandler}
        endHandler={props.endHandler}
      />
    </div>
  )
}

export default DatePicker
